<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Retract`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6758 8.2589C12.3136 7.91937 11.7462 7.90006 11.3607 8.23066L4.32997 14.2596C3.91665 14.614 3.86891 15.2364 4.22334 15.6497C4.57777 16.0631 5.20015 16.1108 5.61347 15.7564L11.9938 10.2851L18.3616 15.7687C18.7761 16.1256 19.4013 16.0789 19.7582 15.6645C20.115 15.2501 20.0684 14.6248 19.654 14.268L12.6864 8.26791C12.6829 8.26488 12.6794 8.26188 12.6758 8.2589Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/></svg>
</template>
<script>

export default {
  name: 'IconRetract',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
